/* eslint-disable indent */
import React, { Fragment } from 'react';
import { NavLink } from 'redux-first-router-link';
import { InView } from 'react-intersection-observer';
import { getFileName, truncate, isValid, isText, segmentTrackEvent } from '../../utils';
import {  setCardImage } from '../../imgixUtils';
import { SITE_HOST } from '../../consts';
import ArticleCard from './ArticleCard';
import './lander-pw.scss';

const OurPicks = ({
    data, header, isMobile, isClient, isHomepage
 }) => {
    const {
      name, 
      largeFeaturedArticleUrl, 
      largeFeaturedArticleTitle, 
      largeFeaturedArticleSponsored, 
      largeFeaturedArticleAuthor, 
      largeFeaturedArticleCategory, 
      largeFeaturedArticleCategoryImage, 
      isCustomContent,
      featuredStories
	} = data;
  if (!isValid(largeFeaturedArticleCategoryImage) || !isValid(featuredStories)) { return null; }
	const {
      card,
      bigcard,
      imageCreditURL,
      universalCredit,
      categoryImage,
      topcardMobile,
      imageAlt,
    } = largeFeaturedArticleCategoryImage;

    let { imageCredit } = largeFeaturedArticleCategoryImage;

    if (!isText(imageCredit) && isText(universalCredit)) {
      imageCredit = universalCredit;
    }

    const rootMargin = `0% 0% ${isMobile ? '50%' : '25%'} 0%`;
    const showCategory = true;

    let renderedFeaturedStory = null;
    if (isValid(largeFeaturedArticleTitle)) {
      const featuredAuthorName =  isValid(largeFeaturedArticleAuthor) ? largeFeaturedArticleAuthor.name : '';
      const isRecipeArticle = largeFeaturedArticleCategory === "recipes";
      const newFeaturedUrl = isRecipeArticle ? `${SITE_HOST}/${largeFeaturedArticleUrl}` : `/${largeFeaturedArticleUrl}`;
      const featuredImageSrc = isValid(bigcard) ? bigcard : card;
      const featuredImageAlt =  isValid(imageAlt) ? imageAlt : getFileName(featuredImageSrc);

      const featuredCard = (
        <div className="card-wrapper">
          <div className="card-details">
              <div className={`card-author`}>
                {showCategory &&
                <div className="card-author-category">{largeFeaturedArticleCategory} </div>
                }
                { (largeFeaturedArticleSponsored === 'Sponsored') ? (
                  <div className="sponsored">{showCategory ? '/ ' : ''}Sponsored</div>
                ) : ( 
                  <div className="card-author-name">{showCategory ? '/ ' : ''}{featuredAuthorName && featuredAuthorName} </div>
                )}
              </div>
              <h3
                className="card-headline"
                dangerouslySetInnerHTML={{ __html: largeFeaturedArticleTitle }}>
              </h3>
          </div>
        </div>
      );

      const featuredCardImg = 
          <div className="card-img-container">
            {(featuredImageSrc) &&
                <Fragment>
                  <img className='card-img' src={featuredImageSrc} alt={featuredImageAlt} />
                  {isText(imageCredit) && <span className="img-credit" dangerouslySetInnerHTML={ { __html: imageCredit } }></span>}
                </Fragment>
            }
          </div>

      renderedFeaturedStory = isRecipeArticle ? (
        <a className="article-card featured-article" href={newFeaturedUrl}>
          {featuredCardImg}
          {featuredCard}
        </a>
      ) : (
        <NavLink className="article-card featured-article" to={newFeaturedUrl}>
          {featuredCardImg}
          {featuredCard}
        </NavLink>
      )
    }


    let renderedStories = null;
    if (isValid(featuredStories)) {
      renderedStories =  featuredStories.map((article, i) => {
        if (!isValid(article)) {
          return null;
        }
        const { title, category, sponsored, author, url, isCustomContent, authorName } = article;
        const showPubdate = false;
        if (isValid(authorName)) {
          if (!isValid(article.cardClass)) {
            article.cardClass = "big-card"
          }
          return <ArticleCard key={i} data={article} isMobile={isMobile} shouldDisplaySponsored={true} showCategory={showCategory} showPubdate={showPubdate} isClient={isClient}/>
        } else {
          const authorNameValid =  isValid(author) ? author.name : '';
          const renderedDate = '';
          const isRecipeArticle = category === "recipes";
          const newUrl = isRecipeArticle ? `${SITE_HOST}/${url}` : `/${url}`;
          article.cardClass = "big-card";
          const imageSrc = setCardImage(article, isMobile);
          const imageAlt =  getFileName(imageSrc);
          let imageCredit, universalCredit;
          if (isValid(article.categoryImage)) {
            universalCredit = article.categoryImage.universalCredit;
            imageCredit = article.categoryImage.imageCredit;
          }

          if (!isText(imageCredit) && isText(universalCredit)) {
            imageCredit = universalCredit;
          }
          const card = (
            <div className="card-wrapper col-3 col-2-sm">
              <div className="card-details">
                  <div className={`card-author`}>
                    { showCategory && 
                      <div className="card-author-category">{category} </div>
                    }
                    { (sponsored === 'Sponsored') ? (
                      <div className="sponsored">{showCategory ? '/ ' : ''}Sponsored</div>
                    ) : ( 
                      <div className="card-author-name">
                      {showCategory ? '/ ' : ''}
                      {authorNameValid && authorNameValid}
                      {showPubdate ? ' / ' : ''}
                      </div>
                    )}
                    { showPubdate && 
                      <div className="card-author-date">{renderedDate}</div>
                    }
                  </div>
                  <h3
                    className="card-headline new-our-picks"
                    dangerouslySetInnerHTML={{ __html: title }}>
                  </h3>
              </div>
            </div>
          );

          const cardImg = 
            <div className="card-img-container col-3 col-2-sm">
              {(imageSrc) &&
                  <Fragment>
                    <img className='card-img' src={imageSrc} alt={imageAlt} />
                    {isText(imageCredit) && <span className="img-credit" dangerouslySetInnerHTML={ { __html: imageCredit } }></span>}
                  </Fragment>
              }
            </div>


          return isRecipeArticle ? (
            <a className="article-card our-picks-article col-3 col-4-sm" href={newUrl}>
              {cardImg}
              {card}
            </a>
          ) : (
            <NavLink className="article-card our-picks-article col-3 col-4-sm" to={newUrl}>
              {cardImg}
              {card}
            </NavLink>
          )
        }
      });
    }

    return (
        <div className="vertical-section our-picks-section col-10 col-4-sm">
          <h2 className='section-hed' dangerouslySetInnerHTML={{ __html: header }}></h2>
          <div className="our-picks-wrapper col-10">
            <div className="article-cards featured-pick col-4 col-4-sm">
              {renderedFeaturedStory}
            </div>
            <div className="article-cards our-picks col-6 col-4-sm">
              {renderedStories}
            </div>
          </div>
        </div>
    );
};

export default OurPicks;
